export default __webpack_public_path__ + "static/supported_browser-242dbb6c4ff38a74d7e66d2be0984a93.jpg";